let getNetwork = () => {
  const href = location.href;

  if (href.match(/^file?:\/\/+.*/i)) {
    return 'file';
  }

  if (href.match(/^http[S]?:\/\/(localhost)+.*/i)) {
    return 'file';
  }

  if (href.match(/^http[s]?:\/\/(localhost|local)+.*/i)) {
    return 'local';
  }

  if (href.match(/^http[s]?:\/\/(wstatic\.plaync\.co\.kr)/)) {
    return 'wstatic';
  }

  if (href.match(/^http[s]?:\/\/(wstatic-cdn\.plaync\.com)/)) {
    return 'wstatic';
  }

  if (href.match(/^http[s]?:\/\/(opdev\.|op-|opdev-)+.*/i)) {
    return 'op';
  }

  if (href.match(/^http[s]?:\/\/(rc\.|rc-)+.*/i)) {
    return 'rc';
  }

  if (href.match(/^http[s]?:\/\/(sb\.|sb-)+.*/i)) {
    return 'sb';
  }

  return 'live';
};

export default getNetwork;
